// extracted by mini-css-extract-plugin
export default {"removeBottomBorder":"RemoveBottomBorderFromTd_removeBottomBorder__1o87K"};